// The application's events, notified by hooks and components, consumed by
// whoever subscribes: the analytics client, devtools, a console logger. The
// server has the same shape on Rails.event; names are identical on both.
export interface RhinoEventContext {
  pageViewId?: string;
  baseOwnerId?: string;
}

export interface RhinoEvent {
  name: string;
  payload: Record<string, unknown>;
  context?: RhinoEventContext;
}

export type RhinoEventListener = (event: RhinoEvent) => void;

export interface RhinoEventBus {
  notify: (
    name: string,
    payload?: Record<string, unknown>,
    context?: RhinoEventContext
  ) => void;
  subscribe: (listener: RhinoEventListener) => () => void;
}

export const createEventBus = (): RhinoEventBus => {
  const listeners = new Set<RhinoEventListener>();

  return {
    notify(name, payload = {}, context) {
      const event = { name, payload, ...(context ? { context } : {}) };
      listeners.forEach((listener) => {
        try {
          listener(event);
        } catch (error) {
          // A broken subscriber must not take the caller with it.
          console.error(error);
        }
      });
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    }
  };
};

export const rhinoEvents = createEventBus();
